import NutepPromove from "../assets/images/Nutep-promove.png";
import NutepLanca from "../assets/images/Nutep-lanca.png";
import FormacaoEquipe from "../assets/images/Formacao-equipe.png";
import RedeBuriti from "../assets/images/buritibranco.png";
import styled from "styled-components";

const List = styled.li`
  list-style: disc;
  margin-left: 36px;
`;

export const newsData = [
  {
    id: 1,
    category: "Saúde",
    image: NutepPromove,
    title:
      "Treinamento para Profissionais com Foco em Apoio a Famílias de Jovens com Paralisia Cerebral",
    content:
      "NUTEP realiza curso online sobre reabilitação neuromotora, focado no modelo de Serviço Centrado na Família (SCF).",
    contentFull: (
      <>
        <p>
          Entre os dias 17 e 31 de outubro, e 07, 14, 21 e 28 de novembro de
          2024, ocorreu o Curso de Formação: “Tratamentos Efetivos na
          Reabilitação Neuromotora”, destinado à equipe multiprofissional que
          atende crianças e adolescentes com paralisia cerebral no Núcleo de
          Tratamento e Estimulação Precoce (NUTEP).
        </p>
        <br />
        <p>
          Realizado de forma online pelo Google Meet, das 19h30 às 20h30, o
          curso foi ministrado pela Profa. Marina de Brito Brandão, terapeuta
          ocupacional e professora da Universidade Federal de Minas Gerais, e
          pelas terapeutas ocupacionais Aline Martins Feitosa e Rachel Helena
          Oliveira, integrantes do Programa de Ciências da Reabilitação.
        </p>
        <br />
        <p>
          O curso integra o Programa de Atenção às Famílias, desenvolvido pelo
          NUTEP, e tem como princípio o modelo de Serviço Centrado na Família
          (SCF). Esse modelo valoriza a parceria entre os profissionais e as
          famílias das crianças atendidas, reconhecendo os pais como
          especialistas nas necessidades de seus filhos. Além disso, promove o
          suporte ao papel da família na tomada de decisões sobre os serviços
          prestados.
        </p>
        <br />
        <p>
          Segundo a Profa. Marina Brandão, o SCF baseia-se em premissas como:
        </p>
        <br />
        <ul>
          <List>Os pais sabem e desejam o melhor para suas crianças.</List>
          <List>Cada família é única e possui necessidades específicas.</List>
          <List>
            O desenvolvimento ótimo da criança ocorre dentro de um contexto
            familiar e comunitário de suporte.
          </List>
        </ul>
        <br />
        <p>
          Diferente das abordagens tradicionais, em que as decisões são tomadas
          exclusivamente pelos profissionais, o SCF promove o envolvimento ativo
          das famílias no planejamento e execução dos cuidados. Essa abordagem
          fortalece a relação entre os profissionais e as famílias,
          proporcionando melhores resultados para o bem-estar e a saúde das
          crianças.
        </p>
        <br />
        <p>
          Com o curso, espera-se que os profissionais do NUTEP estejam ainda
          mais preparados para implementar soluções baseadas no SCF, ampliando a
          eficiência do atendimento e o impacto positivo na vida das crianças e
          adolescentes com paralisia cerebral e suas famílias.
        </p>
        <br />
        <b>Fonte: Direção do NUTEP.</b>
      </>
    ),
  },
  {
    id: 2,
    category: "Saúde",
    image: NutepLanca,
    title: "Projeto de assistência a crianças com seletividade alimentar",
    content:
      "O NUTEP lança projeto de assistência a crianças com seletividade alimentarpara crianças de 6 a 24 meses, focado em combater a seletividade alimentar e promover introdução saudável.",
    contentFull: (
      <>
        <p>
          O NUTEP (Núcleo de Tratamento e Estimulação Precoce) lança projeto de
          assistência a crianças com seletividade alimentar anuncia a criação de
          um grupo de intervenção para crianças de 6 a 24 meses com o objetivo
          de combater o aumento da seletividade alimentar, um desafio crescente
          na infância. O programa visa promover uma introdução alimentar
          saudável, prevenindo e tratando dificuldades relacionadas à
          alimentação.
        </p>
        <br />
        <p>Entre os principais benefícios, destacam-se:</p>
        <br />
        <ul>
          <li>
            Prevenção Precoce: Ampliação do repertório alimentar das crianças,
            considerando as diferentes consistências e necessidades de cada,
            para uma nutrição funcional.
          </li>
          <li>
            Desenvolvimento de Habilidades Sensório-Motoras Orais: Melhora das
            funções de sucção, mastigação e deglutição, com o intuito de reduzir
            recusas e aversões alimentares. O uso de atividades lúdicas e
            experiências positivas será essencial nesse processo.
          </li>
          <li>
            Apoio Familiar: Orientação prática para os cuidadores, com
            estratégias para fortalecer a aceitação de novos alimentos e tornar
            a alimentação mais agradável e variada.
          </li>
        </ul>
        <br />
        <p>
          Esse projeto visa proporcionar uma base sólida para o desenvolvimento
          saudável da alimentação infantil, com foco na qualidade de vida e
          bem-estar das crianças e no suporte contínuo às famílias.
        </p>
        <br />
        <b>Fonte: Direção do NUTEP.</b>
      </>
    ),
  },
  {
    id: 3,
    category: "Saúde",
    image: FormacaoEquipe,
    title:
      "Formação de Equipes Multiprofissionais em Intervenção Precoce e Reabilitação de Crianças e Adolescentes com TEA em municípios do Ceará",
    content:
      "NUTEP conclui formação multiprofissional em intervenção precoce no TEA, capacitando 30 profissionais de municípios do Ceará. ",
    contentFull: (
      <>
        <p>
          NUTEP realiza formação para equipes multiprofissionais em intervenção
          precoce e reabilitação de crianças com TEA
        </p>
        <br />
        <p>
          O Núcleo de Tratamento e Estimulação Precoce (NUTEP), em parceria com
          o Projeto CONECTEA, a Universidade Federal do Ceará, o CETREDE e o
          CAVIVER, realizou a primeira formação para equipes multiprofissionais
          focada em intervenção precoce e reabilitação de crianças e
          adolescentes com Transtorno do Espectro Autista (TEA). O curso foi
          oferecido durante os meses de outubro, novembro e dezembro de 2024.
        </p>
        <br />
        <p>
          O objetivo da formação foi capacitar profissionais das áreas de
          fisioterapia, enfermagem, fonoaudiologia, psicologia, educação física
          e terapia ocupacional, proporcionando as ferramentas necessárias para
          avaliar e intervir precocemente com crianças autistas, além de prestar
          suporte técnico às famílias.
        </p>
        <br />
        <p>
          A primeira turma contou com 30 profissionais de instituições que
          atendem ao público com TEA, provenientes de municípios do interior do
          Ceará, incluindo Alto Santo, Beberibe, Irauçuba, Jaguaretama,
          Jaguaribe, Jaguaribara, Pentecoste, Solonópole, São Gonçalo e
          Uruburetama.
        </p>
        <br />
        <p>
          Com uma carga horária total de 70 horas, o curso foi dividido em 23
          horas de aulas teóricas, 37 horas de aulas práticas e 10 horas
          dedicadas ao monitoramento das ações assistenciais realizadas pelos
          participantes. A equipe multiprofissional do NUTEP, especializada em
          TEA, atuou como facilitadora, além de oferecer suporte técnico para a
          organização dos serviços assistenciais nas instituições participantes.
        </p>
        <br />
        <p>
          O NUTEP destacou a importância de um treinamento pautado nas melhores
          práticas e nas evidências científicas, adaptado às necessidades
          específicas das crianças e adolescentes autistas. A capacitação visa
          ampliar as oportunidades de assistência, inclusão social e apoio aos
          familiares e cuidadores dessa população.
        </p>
        <br />
        <b>Fonte: Direção do NUTEP.</b>
      </>
    ),
  },
  {
    id: 4,
    category: "Saúde",
    title: "Rede Buriti",
    image: RedeBuriti,
    content:
      "A Rede Buriti-SD é a primeira rede de Pesquisa, Desenvolvimento e Inovação (PD&I) em síndrome de Down (SD) do Brasil, fruto da colaboração entre a comunidade científica e a sociedade civil.",
    contentFull: (
      <>
        <p>
          A Rede Buriti-SD é a primeira rede de Pesquisa, Desenvolvimento e
          Inovação (PD&I) em síndrome de Down (SD) do Brasil, fruto da
          colaboração entre a comunidade científica e a sociedade civil.
        </p>
        <p>
          Através dela pretendemos melhorar o acesso de pessoas com síndrome de
          Down aos serviços de saúde e ajudar na elaboração de políticas
          públicas, além de colaborar para avanços científicos e inovação com
          impacto social.
        </p>
        <br />
        <p>
          Ao conectar-se e manter uma unidade com objetivos comuns, há um
          fortalecimento natural de cada um e do todo.
        </p>
        <br />
        <p>
          O propósito é integrar diferentes entidades (universidades, sociedade
          civil e instituições) para avançar nas ações que contemplem a
          observação e o aumento da conscientização da síndrome de Down em nosso
          país, buscando sempre a melhoria das condições de vida, saúde,
          educação e cidadania.
        </p>
        <br />
        <p>
          Através da inovação, queremos apontar caminhos que favoreçam a
          disseminação de informações e dêem subsídios para a elaboração de
          novas diretrizes voltadas às pessoas com síndrome de Down.
        </p>
        <br />
        <p>A rede vai atuar em quatro esferas principais:</p>
        <br />
        <p>
          Formação da Coorte Brasileira de Pessoas co síndrome de Down Coorte é
          a reunião de um grupo de indivíduos que compartilham uma
          característica comum: idade, sexo, local de nascimento, exposição a um
          determinado agente ou a presença de uma condição médica específica,
          por exemplo.
        </p>
        <br />
        <p>
          Criação de um Biobanco Nacional O Biobanco irá reunir amostras
          biológicas (sangue, tecidos, DNA e outros materiais biológicos
          humanos) coletadas dos participantes da coorte.
        </p>
        <br />
        <p>
          Criação de uma Base de dados de larga escala Será uma base de dados
          brasileira com novas informações sobre pessoas com síndrome de Down
          contendo variáveis clínicas, sociodemográficas, educacionais e
          biológicas de relevância científica e clínica.
        </p>
        <br />
        <p>
          Criação do Observatório em Saúde para a síndrome de Down Um
          Observatório em Saúde para a síndrome de Down é uma plataforma de
          âmbito nacional que reúne, para amplo acesso, informações atualizadas
          extraídas das diversas bases de dados oficiais sobre a saúde e as
          características sociais e demográficas desse público. 
        </p>
        <br />
        <p>
          Somos especialistas brasileiros com experiência em diferentes áreas.
          Iremos atuar de forma complementar: epidemiologia,
          bioestatística/bioinformática, imunologia, genética, neurofisiologia e
          neuropsiquiatria. Nossa equipe também conta com profissionais
          qualificados para a gestão de um projeto dessa dimensão, que terá
          abrangência e capilaridade em âmbito nacional.
        </p>
        <br />
        <p>
          14 grupos de pesquisa nacionais, 6 grupos de pesquisa internacionais e
          22 intituições de sociedade civil
        </p>
        <br />
        <p>
          Por meio da sociedade civil, a Rede também irá atuar na disseminação
          de informações, promovendo a educação da comunidade de pessoas com
          síndrome de Down e seus familiares.
        </p>
        <br />
        <p>
          A Rede será desenvolvida com apoio de polos multiplicadores espalhados
          por todas as regiões do Brasil.
        </p>
        <br />
        <p>
          Chamados Buritis-SD, são instituições que já atendem pessoas com
          síndrome de Down e que, pela sua importância, conseguem criar um
          efeito transformador onde se encontram.
        </p>
        <br />
        <br />
        <b>Fonte: Direção do NUTEP.</b>
      </>
    ),
  },
];
